"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require("./");

class EvaluatorCertificationCertificate {
  static thaw(evaluatorCertificationCertificateObj) {
    if (evaluatorCertificationCertificateObj == null) return null;
    const evaluatorCertificationCertificate = new EvaluatorCertificationCertificate();
    if (evaluatorCertificationCertificateObj.id != null) evaluatorCertificationCertificate.setId(evaluatorCertificationCertificateObj.id);
    if (evaluatorCertificationCertificateObj.blobName != null) evaluatorCertificationCertificate.setBlobName(evaluatorCertificationCertificateObj.blobName);
    if (evaluatorCertificationCertificateObj.certificateUrl != null) evaluatorCertificationCertificate.setCertificateUrl(evaluatorCertificationCertificateObj.certificateUrl);
    if (evaluatorCertificationCertificateObj.continuingEducationCredits != null) evaluatorCertificationCertificate.setContinuingEducationCredits(evaluatorCertificationCertificateObj.continuingEducationCredits);
    if (evaluatorCertificationCertificateObj.expirationDate != null) evaluatorCertificationCertificate.setExpirationDate(_luxon.DateTime.fromISO(evaluatorCertificationCertificateObj.expirationDate));
    if (evaluatorCertificationCertificateObj.createdAt != null) evaluatorCertificationCertificate.setCreatedAt(_luxon.DateTime.fromISO(evaluatorCertificationCertificateObj.createdAt));
    if (evaluatorCertificationCertificateObj.evaluatorCertificationId != null) evaluatorCertificationCertificate.setEvaluatorCertificationId(evaluatorCertificationCertificateObj.evaluatorCertificationId);
    if (evaluatorCertificationCertificateObj.evaluatorCertification != null) evaluatorCertificationCertificate.setEvaluatorCertification(_.EvaluatorCertification.thaw(evaluatorCertificationCertificateObj.evaluatorCertification));
    return evaluatorCertificationCertificate;
  }

  static thawList(evaluatorCertificationCertificateObjList) {
    if (evaluatorCertificationCertificateObjList == null) return [];
    var evaluatorCertificationCertificates = [];

    for (var i = 0; i < evaluatorCertificationCertificateObjList.length; i++) {
      evaluatorCertificationCertificates.push(EvaluatorCertificationCertificate.thaw(evaluatorCertificationCertificateObjList[i]));
    }

    return evaluatorCertificationCertificates;
  }

  static freeze(evaluatorCertificationCertificate) {
    if (evaluatorCertificationCertificate == null) return null;
    var evaluatorCertificationCertificateObj = {};
    if (evaluatorCertificationCertificate.getId() != null) evaluatorCertificationCertificateObj.id = evaluatorCertificationCertificate.getId();
    if (evaluatorCertificationCertificate.getBlobName() != null) evaluatorCertificationCertificateObj.blobName = evaluatorCertificationCertificate.getBlobName();
    if (evaluatorCertificationCertificate.getCertificateUrl() != null) evaluatorCertificationCertificateObj.certificateUrl = evaluatorCertificationCertificate.getCertificateUrl();
    if (evaluatorCertificationCertificate.getContinuingEducationCredits() != null) evaluatorCertificationCertificateObj.continuingEducationCredits = evaluatorCertificationCertificate.getContinuingEducationCredits();
    if (evaluatorCertificationCertificate.getExpirationDate() != null) evaluatorCertificationCertificateObj.expirationDate = evaluatorCertificationCertificate.getExpirationDate();
    if (evaluatorCertificationCertificate.getCreatedAt() != null) evaluatorCertificationCertificateObj.createdAt = evaluatorCertificationCertificate.getCreatedAt();
    if (evaluatorCertificationCertificate.getEvaluatorCertificationId() != null) evaluatorCertificationCertificateObj.evaluatorCertificationId = evaluatorCertificationCertificateObj.getEvaluatorCertificationId();
    if (evaluatorCertificationCertificate.getEvaluatorCertification() != null) evaluatorCertificationCertificateObj.evaluatorCertification = _.EvaluatorCertification.freeze(evaluatorCertificationCertificateObj.getEvaluatorCertification());
    return evaluatorCertificationCertificateObj;
  }

  static freezeList(evaluatorCertificationCertificates) {
    if (evaluatorCertificationCertificates == null) return [];
    var evaluatorCertificationCertificateObjList = [];

    for (var i = 0; i < evaluatorCertificationCertificates.length; i++) {
      evaluatorCertificationCertificateObjList.push(EvaluatorCertificationCertificate.freeze(evaluatorCertificationCertificates[i]));
    }

    return evaluatorCertificationCertificateObjList;
  }

  constructor() {
    this.setId(null);
    this.setBlobName(null);
    this.setCertificateUrl(null);
    this.setContinuingEducationCredits(null);
    this.setExpirationDate(null);
    this.setCreatedAt(null);
    this.setEvaluatorCertificationId(null);
    this.setEvaluatorCertification(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setBlobName(blobName) {
    this.blobName = blobName;
  }

  setCertificateUrl(certificateUrl) {
    this.certificateUrl = certificateUrl;
  }

  setContinuingEducationCredits(continuingEducationCredits) {
    this.continuingEducationCredits = continuingEducationCredits;
  }

  setExpirationDate(expirationDate) {
    this.expirationDate = expirationDate;
  }

  setCreatedAt(createdAt) {
    this.createdAt = createdAt;
  }

  setEvaluatorCertificationId(evaluatorCertificationId) {
    this.evaluatorCertificationId = evaluatorCertificationId;
  }

  setEvaluatorCertification(evaluatorCertification) {
    this.evaluatorCertification = evaluatorCertification;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getBlobName() {
    return this.blobName;
  }

  getCertificateUrl() {
    return this.certificateUrl;
  }

  getContinuingEducationCredits() {
    return this.continuingEducationCredits;
  }

  getExpirationDate() {
    return this.expirationDate;
  }

  getCreatedAt() {
    return this.createdAt;
  }

  getEvaluatorCertificationId() {
    return this.evaluatorCertificationId;
  }

  getEvaluatorCertification() {
    return this.evaluatorCertification;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluatorCertificationCertificate;